export { default as TextInputWithMask } from "./text-input-with-mask";
